export default __webpack_public_path__ + "static/instagram-worthy-hostels-146c62aa43381d19c8f2b8abb90bddf9.jpg";